<template>
    <div class="page"  v-bind:class="{ 'fill-page-background': fillPageColor }">
      <Header />
      <router-view></router-view>
      <Footer />
    </div>
</template>
<style scoped>
.fill-page-background {
    background-color: #961e23;
}
</style>

<script>
import Utils from './../../js/helpers/Utils';
import Header from './header';
import Footer from './footer';

export default {
    data() {
        return {
            fillPageColor: false,
        }
    },
    created (){
        if(this.$route.path == '/impersonate'){
            this.fillPageColor = true;
        }
    },
    mounted(){
        window.$("header").ready(() => {
            setTimeout(() => {
                if(window.top.document.querySelector("header").clientHeight <= 0){
                    Utils.loadHeader();
                }
            }, 200);
        });
    },
    components: {
        Header,
        Footer,
    }
}
</script>
